import React from "react";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import Container from "@mui/material/Container";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";

import Organize from "./organize/Organize";
import CollectionView from "./collections/CollectionView";
import ContentView from "./content/ContentView";
import AnthologyView from "./anthologies/AnthologyView";
import ModuleView from "./modules/ModuleView";

import { Navigate, Route, Routes } from "react-router-dom";
import { CreatorProvider } from "./CreatorContext";
import RequireRoles from "../auth/RequireRoles";
import DashboardView from "./dashboard/DashboardView";
import CreatorNavigation from "./CreatorNavigation";
import UploadMedia from "./organize/upload/UploadMedia";

// MAC Table
import ManageContentAccess from "./content/edit/ManageContentAccess";
import ManageModuleAccess from "./modules/edit/ManageModuleAccess";
import ManageCollectionAccess from "./collections/edit/ManageCollectionAccess";
import { creatorRoles, organizeRoles } from "../auth/authUtils";

const ADMIN = ["ROLE_ADMIN"];

const CreatorApplication = () => {
  return (
    <CreatorProvider>
      <DndProvider backend={HTML5Backend}>
        <Container id="creator-application" disableGutters>
          <ApplicationHeader applicationNavigation={<CreatorNavigation />} />

          <Routes>
            <Route
              path="home/*"
              element={
                <RequireRoles roles={creatorRoles}>
                  <ApplicationPanel id="application-panel-dashboard">
                    <DashboardView />
                  </ApplicationPanel>
                </RequireRoles>
              }
            />
            <Route
              path="organize/*"
              element={
                <RequireRoles roles={organizeRoles}>
                  <Organize />
                </RequireRoles>
              }
            />
            <Route
              path="upload/*"
              element={
                <RequireRoles roles={creatorRoles}>
                  <UploadMedia />
                </RequireRoles>
              }
            />
            <Route
              path="anthologies/*"
              element={
                <RequireRoles roles={creatorRoles}>
                  <ApplicationPanel
                    id="application-panel-anthologies"
                    background="white"
                  >
                    <AnthologyView />
                  </ApplicationPanel>
                </RequireRoles>
              }
            />
            <Route
              path="manage-access/module/:id/*"
              element={
                <RequireRoles roles={ADMIN}>
                  <ManageModuleAccess />
                </RequireRoles>
              }
            />
            <Route
              path="manage-access/collection/:id/*"
              element={
                <RequireRoles roles={ADMIN}>
                  <ManageCollectionAccess />
                </RequireRoles>
              }
            />
            <Route
              path="manage-access/content/:id/*"
              element={
                <RequireRoles roles={ADMIN}>
                  <ManageContentAccess />
                </RequireRoles>
              }
            />
            <Route
              path="content/*"
              element={
                <RequireRoles roles={organizeRoles}>
                  <ApplicationPanel
                    id="application-panel-content"
                    background="white"
                  >
                    <ContentView />
                  </ApplicationPanel>
                </RequireRoles>
              }
            />
            <Route
              path="collections/*"
              element={
                <RequireRoles roles={creatorRoles}>
                  <ApplicationPanel
                    id="application-panel-collections"
                    background="white"
                  >
                    <CollectionView />
                  </ApplicationPanel>
                </RequireRoles>
              }
            />
            <Route
              path="modules/*"
              element={
                <RequireRoles roles={creatorRoles}>
                  <ApplicationPanel
                    id="application-panel-modules"
                    background="white"
                  >
                    <ModuleView />
                  </ApplicationPanel>
                </RequireRoles>
              }
            />
            <Route path="*" element={<Navigate to="home" replace />} />
          </Routes>
        </Container>
      </DndProvider>
    </CreatorProvider>
  );
};

export default CreatorApplication;
